import {
  classNames,
  SBArr,
  LHCRed,
  LHCBlue,
  LHCGreen,
  calcLHCBetArr,
} from "../../../../../tool";
import Number from "../../../../../components/number";
import styles from "../index.module.scss";
export default function SB(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;

  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        // let betArr = [];
        // if(secondPlay.code === 'SBZ') {
        //   betArr =SBArr
        // } else {
        //   betArr = calcLHCBetArr(
        //     secondPlay.code === "RB"
        //       ? LHCRed
        //       : thirdPlayType.code === "BB"
        //       ? LHCBlue
        //       : LHCGreen,
        //     item.name,
        //     25
        //   );
        // }
        return (
          <div
            key={index}
            className={classNames(
              styles.SB,
              secondPlay.code === "SBZ" ? styles.SBZ : "",
              styles.playItem,
              active ? styles.active : ""
            )}
            onClick={() => onBet(item)}
          >
            <div className={styles.leftName}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.odds}>
                {
                  playOddInfo[
                    `LHC_${firstPlay.code}_${
                      secondPlay.code || firstPlay.code
                    }${item.code}`
                  ]
                }
              </div>
            </div>
            <div
              className={classNames(
                styles.rightNumber,
                item.name.length > 2 ? styles.big : ""
              )}
            >
              {(secondPlay.code === "SBZ"
                ? SBArr[index]
                : calcLHCBetArr(
                    secondPlay.code === "RB"
                      ? LHCRed
                      : secondPlay.code === "BB"
                      ? LHCBlue
                      : LHCGreen,
                    item.name,
                    25
                  )
              ).map((it, idx) => {
                return (
                  <Number
                    key={idx}
                    number={it}
                    width={"7.556rem"}
                    height={"7.556rem"}
                    fontSize={"3.551rem"}
                    active={active}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
